(ns arthur.flow.condition.interior
  "Teeth presence and temporal contour conditioning. The contrast measurement
  remains available for diagnosis; visibility is an editable freeze decision."
  (:require [arthur.domain.geom :as geom]))

(defn apply-defaults
  [{:keys [fps teeth-on teeth-dwell teeth-smooth aperture-cut]}
   measures aperture]
  (let [peak (reduce max aperture)
        dwell (or teeth-dwell (js/Math.round (* (or fps 30) 0.08)))
        raw (mapv (fn [m a]
                    (if (and (:contour m) (pos? peak)
                             (>= (/ a peak) aperture-cut))
                      (:contrast m) 0))
                  measures aperture)
        shown (loop [f 0 live false since 0 out []]
                (if (= f (count raw))
                  out
                  (let [want (> (nth raw f) (if live (* teeth-on 0.7) teeth-on))
                        change? (and (not= want live) (>= since dwell))
                        live (if change? want live)
                        since (if change? 0 (inc since))]
                    (recur (inc f) live since
                           (conj out (and live (some? (:contour (nth measures f)))))))))
        contours (mapv :contour measures)
        smoothed (mapv (fn [f points]
                         (if (or (nil? points) (not (nth shown f))
                                 (zero? teeth-smooth))
                           points
                           (let [near (keep (fn [j]
                                              (let [k (max 0 (min (dec (count contours)) j))]
                                                (when (and (nth shown k)
                                                           (= (count points)
                                                              (count (nth contours k))))
                                                  (nth contours k))))
                                            (range (- f teeth-smooth)
                                                   (inc (+ f teeth-smooth))))]
                             (if (seq near)
                               (mapv geom/centroid (apply map vector near))
                               points))))
                       (range (count contours)) contours)]
    {:contours smoothed :shown shown
     :contrast (mapv :contrast measures)
     :debug (mapv :debug measures)}))
